// import lightModeLogo from '@/assets/images/logo-black.svg';
// import lightModeLogoAlpha from '@/assets/images/logo-black-alpha.svg';
// import darkModeLogo from '@/assets/images/logo-white.svg';
// import darkModeLogoAlpha from '@/assets/images/logo-white-alpha.svg';
// import lightmodeBanner from '@/assets/images/banner-light.png';
// import darkmodeBanner from '@/assets/images/banner-dark.png';
import lightModeLogoNew from '@/assets/images/logo-black-new.svg'
import darkModeLogoNew from '@/assets/images/logo-white-new.svg'

export const siteSettings = {
  lightLogo: lightModeLogoNew,
  darkLogo: darkModeLogoNew,
  // lightBanner: lightmodeBanner,
  // darkBanner: darkmodeBanner,
  width: 168,
  height: 80,
};
